var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.36 27.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-D4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3,15.67a3.48,3.48,0,0,0-2.77,4.15,3.51,3.51,0,1,0,6.88-1.42,3.48,3.48,0,0,0-4.1-2.73Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.05,8.17H7.89c-.4,0-.79.64-1,.86s-.29.26-.44.44c-.93,1.1-.74.88-1.93.88H2.7c-1.31,0-2,.34-2.46,1.24-.36.73-.21,2.6-.21,3.55S0,25.58.08,26.17a2.21,2.21,0,0,0,2.07,1.69H19.79c1.53,0,2.07-.71,2.12-2.13V16a10,10,0,0,1-6.86-7,7.38,7.38,0,0,0-1-.88ZM5.53,19.55a5.46,5.46,0,1,1,5.89,5,5.45,5.45,0,0,1-5.89-5Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,7.57a4.65,4.65,0,0,0,0-1.36l1.46-1.13a.35.35,0,0,0,.08-.44L29.93,2.25a.33.33,0,0,0-.3-.17l-.11,0-1.72.69a4.71,4.71,0,0,0-1.17-.68L26.37.28A.33.33,0,0,0,26,0H23.28a.34.34,0,0,0-.34.28l-.26,1.83a5.26,5.26,0,0,0-1.17.68L19.8,2.1a.32.32,0,0,0-.13,0,.36.36,0,0,0-.3.17L18,4.64a.34.34,0,0,0,.08.44l1.45,1.13c0,.22,0,.45,0,.68s0,.46,0,.68L18.08,8.7a.34.34,0,0,0-.08.44l1.37,2.39a.36.36,0,0,0,.31.17l.11,0L21.51,11a4.84,4.84,0,0,0,1.16.68l.27,1.83a.33.33,0,0,0,.33.29H26a.34.34,0,0,0,.34-.29l.26-1.83A5.26,5.26,0,0,0,27.8,11l1.71.69a.32.32,0,0,0,.13,0,.34.34,0,0,0,.29-.17l1.38-2.39a.35.35,0,0,0-.08-.44L29.78,7.57h0ZM28.41,6.39a3.21,3.21,0,0,1,0,.5c0,.15,0,.3,0,.51l-.1.77.62.49.74.58-.48.83-.88-.35-.71-.29L27,9.9a4.11,4.11,0,0,1-.87.5l-.73.3-.11.77-.14.93h-1L24,11.47l-.12-.77-.73-.3a4,4,0,0,1-.84-.49l-.63-.49-.73.3-.88.35-.48-.83.74-.58L21,8.18l-.1-.78c0-.21,0-.37,0-.51s0-.3,0-.51l.1-.77-.62-.49-.74-.58.48-.83.88.35.71.29.62-.47a4.11,4.11,0,0,1,.87-.5l.73-.3L24,2.31l.14-.93h1l.13.93.11.77.73.3a4,4,0,0,1,.84.49l.63.49.73-.3.88-.35.48.83-.74.58-.61.49.09.77ZM24.65,4.14a2.76,2.76,0,1,0,2.76,2.75A2.76,2.76,0,0,0,24.65,4.14Zm0,4.13A1.38,1.38,0,1,1,26,6.89,1.38,1.38,0,0,1,24.65,8.27Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD4);
export default __webpack_public_path__ + "static/media/D4.94b804518b509ebfce5c66ce5e6ddd38.svg";
export { ForwardRef as ReactComponent };